import { render, staticRenderFns } from "./templateSayhi.vue?vue&type=template&id=505b7b60"
import script from "./templateSayhi.vue?vue&type=script&lang=js"
export * from "./templateSayhi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports